var _rect, _line, _line2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmokingDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.88074,
    y: 16.2738,
    width: 16.9349,
    height: 3.70461,
    transform: "rotate(-44.2703 1.88074 16.2738)",
    stroke: "#1B2646"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 13.1131,
    y1: 5.2862,
    x2: 15.5285,
    y2: 7.69418,
    stroke: "#1B2646"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 5.35297,
    y1: 12.9151,
    x2: 7.76831,
    y2: 15.3231,
    stroke: "#1B2646"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5504 4.36792C14.9046 3.03922 18.9737 1.70304 15.8408 0.532836",
    stroke: "#1B2646",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmokingDark);
export default __webpack_public_path__ + "static/media/smoking-dark.90e133ee18c86bfc8607d6b19241fc75.svg";
export { ForwardRef as ReactComponent };